<template>
  <section>
    <div class="mb-1 head--ticket--detail">
      <div class="pr-07">
        <b-icon variant="primary" icon="credit-card" scale="1.5" ></b-icon>
      </div>
      <div class="detail--stage">
        En la lista
        <b-dropdown @shown="() => stageToggle= false" @hidden="() => stageToggle= true" variant="link" class="p-0 mr-02" :no-caret="true" toggle-class="p-0" :disabled="loading || isAdmin" boundary="scrollParent" v-b-tooltip.hover :title="dateCurrentStage">
          <template #button-content>
            <div class="font--primary">
              {{textStage}}
              <b-icon :icon="stageToggle ? 'chevron-compact-down' : 'chevron-compact-up'"
              aria-hidden="true" scale="1" variant="primary"/>
            </div>
          </template>
          <div class="dropdown-menu-scroll">
            <b-dropdown-item v-for="(stage, index) in optionsTicketStage" :key="index"  @click="changeStage(stage)">{{stage.text}}</b-dropdown-item>
          </div>
        </b-dropdown>
      </div>
      <b-dropdown @shown="() => stateToggle= false" @hidden="() => stateToggle= true" variant="link" class="p-0 mr-02" :no-caret="true" toggle-class="p-0" :disabled="!selectStage.id || loading || isAdmin" dropright boundary="scrollParent" v-b-tooltip.hover :title="subStatusDate">
        <template #button-content>
          <div class="d-flex align-items-center">
            <div class="text-left">
              <h1 class="h3 text-primary font--primary">
                <span>{{ clientName }}</span>  
              </h1>
              <h2 class="h5 text-warning font--secondary mb-0"><span>{{ subStatusName }}</span></h2>
            </div>
            <b-icon :icon="stateToggle ? 'chevron-compact-down' : 'chevron-compact-up'"
            aria-hidden="true" scale="1" variant="black" class="ml-1"/>
          </div>
        </template>
        <div class="dropdown-menu-scroll">
          <b-dropdown-item v-for="(status, index) in optionsTicketStatuses" :key="index"  @click="changeStatus(status)">{{status.text}}</b-dropdown-item>
        </div>
      </b-dropdown>
      <color-label v-if="isModal" :colorId="ticket.color_id" :ticketId="ticket.id" :colorArray="colorArray" :isModal="isModal"></color-label>
      <b-button variant="link" v-b-tooltip.hover :title="isModal ? 'Abrir el ticket en pantalla completa' : 'OT y Referencia'" @click="goToTicket()" class="font--secondary" :class="isModal ? 'underline' : 'cursor--auto' ">
        <div class="d-flex align-items-center">
          <feather-icon icon="SendIcon"/>
          <div class="text-left ml-04">
            OT: {{ headData.trackingNumber}} <br>
            Ref: {{ headData.importedId }}
          </div>
        </div>
      </b-button>
      <b-button variant="link" v-b-tooltip.hover title="Ir a la empresa" @click="goToCompany(headData.companyId)" class="font--secondary underline">
        <div class="d-flex align-items-center">
          <icons :icon="'BuildIcon'"></icons>
          <div class="text-left ml-04">
            ID: {{ headData.companyId }} <br>
            {{ headData.companyName }}
          </div>
        </div>
      </b-button>
      <div v-b-tooltip.hover title="Id Póliza" class="font--secondary" v-if="headData.policyId">
        <div class="d-flex align-items-center text-primary font-weight-bold">
          <feather-icon icon="ShieldIcon"/>
          <div class="text-left ml-04 line-height-1">
            ID Póliza <br>
            {{ headData.policyId }}
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex">

    </div>
  </section>
</template>
<script>
import BaseServices from '@/store/services/index'
import colorLabel from '@/views/modules/tickets/components/List/colorLabel.vue'
import {
  BIcon,
  BIconCreditCard,
  BIconChevronCompactUp,
  BIconChevronCompactDown
} from 'bootstrap-vue'
/* eslint-disable vue/no-unused-components */
import Icons from '@/Icons/Icons.vue'
import dayjs from 'dayjs'

export default {
  props: ['ticket', 'masterData', 'colorArray', 'isModal'],
  components: {BIcon, BIconCreditCard, BIconChevronCompactUp, BIconChevronCompactDown, colorLabel, Icons},
  data() {
    return {
      baseService: new BaseServices(this),
      stageToggle: true,
      stateToggle: true,
      selectStage: {},
      selectStatus: {},
      loading: false
    }
  },
  computed: {
    dataUser() {
      return this.$session.get('cas_user')
    },
    isAdmin() {
      return this.dataUser?.role !== 'admin'
    },
    textStage() {
      return this.selectStage.text ? this.selectStage.text : this.currentStageName
    },
    textStatus() {
      return this.selectStatus.text || `${this.clientName} - ${this.subStatusName}`
    },
    optionsTicketStage() {
      const guideTicketStages = []
      return this.masterData.ticket_statuses ? this.masterData.ticket_statuses.reduce((acc, el) => {
        if (!guideTicketStages.includes(el.ticket_stage_code)) {
          guideTicketStages.push(el.ticket_stage_code)
          acc.push({
            text: el.ticket_stage_name,
            id: el.ticket_stage_code
          })
        }
        return acc
      }, []) : []
    },
    optionsTicketStatuses() {
      return this.masterData?.statusFormatted?.length > 0 ? this.masterData.statusFormatted.filter(el => el.ticket_stage_code === this.selectStage.id) : []
    },
    currentStageName() {
      return this.ticket && this.ticket?.current_stage && this.ticket?.current_stage?.name ? this.ticket.current_stage.name : ''
    },
    dateCurrentStage() {
      return this.ticket && this.ticket?.current_stage && this.ticket?.current_stage?.date ? this.formatTimestamp(this.ticket.current_stage.date) : ''
    },
    clientName() {
      return this.ticket && this.ticket?.current_status && this.ticket?.current_status?.client_name ? this.ticket.current_status.client_name : ''
    },
    subStatusName() {
      return this.ticket && this.ticket?.current_status && this.ticket?.current_status?.sub_status_name ? this.ticket.current_status.sub_status_name : ''
    },
    subStatusDate() {
      return this.ticket && this.ticket?.current_status && this.ticket?.current_status?.date ? this.formatTimestamp(this.ticket.current_status.date) : ''
    },
    headData() {
      return { 
        trackingNumber: this.ticket?.delivery?.tracking_number || 'Sin información',
        importedId: this.ticket?.delivery?.imported_id || 'Sin información',
        companyId: this.ticket?.company?.id || '',
        companyName: this.ticket?.company?.name || '',
        policyId: this.ticket?.policyData?.policy_id || ''
      }
    }
  },
  mounted() {
    this.resetValue()
  },
  methods: {
    changeStage(data) {
      this.selectStage = data
    },
    changeStatus(data) {
      this.selectStatus = data
      this.loading = true
      const dataSend = {
        _document: this.ticket._document,
        delivery_id: this.ticket.id,
        user: {
          first_name: this.dataUser?.first_name,
          last_name: this.dataUser?.last_name,
          email: this.dataUser?.email,
          role: this.dataUser?.role
        },
        current_sub_status: {
          code: data.id,
          name:  data.sub_status_name
        },
        current_status: {
          code: data.code,
          agent_name: data.agent_name,
          client_name: data.client_name
        }
      }
      this.baseService.callService('upgradeTickets', dataSend)
        .then(response => {
          this.resetValue()
          this.$emit('updateTicket', true)
        })
        .catch((err) => {
          this.$alert(err)
        })
        .finally(() => {
          this.loading = false 
        })
    },
    resetValue() {
      this.selectStage = {}
      this.selectStatus = {}
    },
    goToTicket() {
      if (this.isModal) window.open(`https://app.enviame.io/tickets/${this.ticket.id}`, '_blank')
    },
    goToCompany(companyId) {
      window.open(`https://app.enviame.io/companies/${companyId}`, '_blank')
    },
    formatTimestamp(timestamp) {
      return dayjs(timestamp).format('YYYY-MM-DD')
    }
  }
}
</script>
<style lang="scss">
  .detail--stage {
    display: grid;
  }
  .dropdown-menu-scroll {
    max-height: 400px;
    overflow-y: auto;
  }
  .underline {
    text-decoration-line: underline;
  }
  .cursor--auto {
    cursor: auto;
  }
</style>